import { render } from "./BaseChartElement.vue?vue&type=template&id=342d4bac&scoped=true&ts=true"
import script from "./BaseChartElement.vue?vue&type=script&lang=ts"
export * from "./BaseChartElement.vue?vue&type=script&lang=ts"

import "./BaseChartElement.vue?vue&type=style&index=0&id=342d4bac&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342d4bac"]])

export default __exports__